module.exports = __webpack_public_path__ + "static/media/Stag-Sans-Bold-Italic.77394da0.otf";